module.exports = __webpack_public_path__ + "static/media/logo.6e3cb398.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Topbar/logo.jpg
// module id = 928
// module chunks = 0